<template>
    <div class="parent-header">
      <header>
        <div class="nav-container">
          <div class="logo-container">
            <router-link :to="'/parent/home'" class="logo-link">
              <img class="logo" :src="logoPath" alt="Logo" />
            </router-link>
          </div>
          <div class="header-actions">
            <router-link
                class="border-btn mx-2 text-decoration-none"
                to="/parent/home"
            >
              <i class="fas fa-dashboard"></i> Dashboard
            </router-link>
            <button
              class="border-btn logout-btn"
              @click="onLogoutBtnClick"
            ><i class="fas fa-sign-out-alt mx-0"></i></button>
          </div>
        </div>
      </header>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  
  export default {
    name: 'ParentHeader',
    data() {
      return {
      };
    },
    computed: {
      ...mapState('user', ['loggedIn', 'user']),
      ...mapState('appState', ['systemParameters']),
      logoPath() {
        return this.systemParameters.LogoPath
          ? this.systemParameters.LogoPath
          : require('@/assets/images/gocbe_logo.png');
      }
    },
    methods: {
      ...mapActions('user', ['logout']),
      onLogoutBtnClick() {
        this.logout();
		  }
    },
  };
  </script>
  
  <style scoped>
  .parent-header {
    position: absolute;
    top: 0;
    width: 100%;
    background: white;
  }
  
  header {
    display: flex;
    box-shadow: 6px 3px 6px #b9b9b929;
    height: var(--header-height, 60px);
    align-items: center;
  }
  
  .nav-container {
    display: flex;
    width: 100%;
    padding: 0 2.5rem;
    align-items: center;
    justify-content: space-between;
  }
  
  .logo-container {
    display: flex;
    height: 56px;
    margin-right: 1.85rem;
  }
  
  .logo-link {
    padding-left: 0;
    height: 52px;
    display: flex;
    align-items: center;
  }
  
  .logo {
    height: 56px;
  }
  
  .header-actions {
    display: flex;
    align-items: center;
  }
  
  .header-secondary-btn {
    background-color: #f8f8f8;
    border: 1px solid #e9e9e9;
    border-radius: 8px;
    box-shadow: 0 3px 6px #d5d5d529;
    padding: 1rem 1.5rem;
    line-height: 1.25;
    margin-left: 1rem;
    color: #231f20;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .header-secondary-btn:hover {
    background-color: #e9ecef;
  }
  
  .qr-btn i,
  .logout-btn i {
    margin-right: 0.5rem;
  }
  
  .qr-modal-content {
    background: #fff;
    border-radius: 10px;
    padding: 0;
  }
  
  .modal-header {
    display: flex;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #eee;
  }
  
  .back-button {
    background: none;
    border: none;
    font-size: 1.2rem;
    color: #007bff;
    cursor: pointer;
    margin-right: 1rem;
  }
  
  .modal-title {
    font-size: 1.2rem;
    font-weight: 500;
    color: #333;
    margin: 0;
  }
  
  .modal-content {
    padding: 2rem;
    text-align: center;
  }
  
  .modal-text {
    font-size: 1rem;
    color: #666;
    margin-top: 1rem;
    line-height: 1.5;
  }
  
  .home-button {
    margin-top: 1.5rem;
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 12px;
    background-color: #007bff;
    color: #fff;
    border: none;
  }
  
  .home-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  @media (max-width: 996px) {
    .nav-container {
      padding: 0 0.5rem;
    }
  
    .logo {
      height: 40px;
    }
  
    .header-secondary-btn {
      padding: 0.75rem 1rem;
      font-size: 0.9rem;
    }
  }
  
  @media (max-width: 480px) {
  
    .header-secondary-btn {
      margin: 0.5rem 0;
      width: 100%;
    }
  }
  </style>